import './Portrait.less';

const Portrait = ({ userPhoto, userName, userFirstName, userLastName }) => {
    const portraitHtml = window.getPortraitHtml(
        userPhoto,
        userFirstName || userName,
        userLastName,
    );

    return (
        <div className="Portrait" dangerouslySetInnerHTML={{ __html: portraitHtml }} />
    );
};

export default Portrait;